/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CreditPurchaseStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    REFUNDED = 'refunded',
}
